import { Component, OnInit , OnDestroy} from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { CommonService } from '../../services/common.service';
import { Serviceprovider } from '../../classes/serviceprovider.interface';
import { Router } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { MatDialog, MatDialogRef } from '@angular/material';
import {ServiceeditComponent} from '../serviceedit/serviceedit.component';
import {ServiceaddComponent} from '../serviceadd/serviceadd.component';
@Component({
  selector: 'app-profilemanage',
  templateUrl: './profilemanage.component.html',
  styleUrls: ['./profilemanage.component.css']
})
export class ProfilemanageComponent implements OnInit {
  tempsprovider: any;
  loading = false;
  addservicediv = 0;
  addsname: any;
  addsid: any
  addfees: any;
  userid: any;
  sprovider: any;
  servicemenu: any;
  specialisation: any;
  services = [];
  special = [];
  allservices: any;
  specialist: any;
  p= 1;
  msg: any;
  action: any;
  cflag: any;
  constructor(private doctorservice: DoctorService, public dialog: MatDialog,
    private commonService: CommonService, private router: Router,  public snackBar: MatSnackBar) {
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
    }

  ngOnInit() {
   this.getData();
  }
  getData() {
    this.loading = true;
    this.doctorservice.getServiceproviderownId(this.userid)
    .subscribe(
      (x: Serviceprovider) => {
        this.loading = false;
        this.sprovider = x;
        this.getSpecialist(this.sprovider[0].id);
        this.getServiceMenus(this.sprovider[0].id);
      });
      this.doctorservice.getServiceproviderownId(this.userid)
      .subscribe(
        (x) => {
          this.loading = false;
          this.tempsprovider = x;
        });
  }
  getServiceMenus(sid) {
    this.loading = true;
    this.doctorservice.getServiceMenus(sid)
    .subscribe (
      (x) => {
        this.loading = false;
        this.servicemenu = x;
        this.getServices();
      });
  }
  getSetSpecialisation() {
    this.loading = true;
    this.doctorservice.getSpecialisation()
    .subscribe (
      (x) => {
        this.specialisation = x;
        this.loading = false;
        for (let i = 0 ; i < this.specialisation.length; i++) {
          this.special.push(this.specialisation[i]);
        }
        this.eliminateSpecialisation();
      });
  }
  eliminateSpecialisation() {
    for (let i = 0 ; i  < this. specialist.length ; i++) {
      for ( let j = 0; j < this.special.length ; j ++) {
        if (this.special[j].id == this.specialist[i]. specialisation_id) {
          this.special.splice(j, 1);
        }
      }
    }
  }
  getSpecialist(sid) {
    this.loading = true;
    this.doctorservice.GetMyAvailableSpecialisation(sid)
    .subscribe(
      (x) => {
        this.specialist = x;
        this.loading = false;
        this.getSetSpecialisation();
      }
    )
  }
  getServices() {
    this.loading = true;
    this.doctorservice.getAllServicess()
    .subscribe (
      (x) => {
        this.allservices = x;
        this.loading = false;
        for (let i = 0; i < this.allservices.length; i ++) {
          this.services.push(this.allservices[i]);
        }
        this.elimateService();
      });
  }
  elimateService() {
    for (let i = 0 ; i  < this. servicemenu.length ; i++) {
      for ( let j = 0; j < this.services.length ; j ++) {
        if (this.services[j].id === this.servicemenu[i]. service_id) {
          this.services.splice(j, 1);
        }
      }
    }
  }
  deleteServicemenu(id) {
    this.loading = true;
    this.doctorservice.deleteMyService(id)
    .subscribe(
      (x) => {
        this.loading = false;
        for (let i = 0; i < this.servicemenu.length; i++) {
          if (this.servicemenu[i].id === id) {
            this.servicemenu.splice(i, 1);
          }
        }
        this.services = [];
        this.getServices();
        this.msg = 'Service Delete successfully';
        this.openSnackBar();
      });
  }
  serviceEdit(id, sid, fees) {
    let sname;
    for (let i = 0 ; i < this.services.length ; i++) {
      if (this.services[i].id === sid) {
        sname = this.services[i].name;
      }
    }
    const dialogRef = this.dialog.open(ServiceeditComponent, {
      width: '320px',
      height: '320px',
      data: {id: id, name: sname, fees: fees}
    } );
    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
       this.getServiceMenus(this.sprovider[0].id);
       this.msg = 'Fees edited successfully';
       this.openSnackBar();
      }
      if (result === 0) {
        this.msg = 'No Change In Fees';
        this.openSnackBar();
       }
    });
  }
  addService(id , name) {
    this.addservicediv = 1;
    this.addsname = name;
    this.addsid = id;
    this.addfees = undefined;
  }
  openSnackBar() {
    this.snackBar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
  cancelDiv() {
    this.addservicediv = 0;
    this.addfees = undefined;
    this.addsname = undefined;
    this.addsid = undefined;
  }
  conFirmAddService() {
    this.loading = true;
    this.doctorservice.addMyService(this.sprovider[0].id, this.addsid, this.addfees)
    .subscribe(
      (x) => {
        this.addservicediv = 0;
        this.addfees = undefined;
        this.addsname = undefined;
        this.addsid = undefined;
        this.loading = false;
        this.services = [];
        this.getServiceMenus(this.sprovider[0].id);
        this.msg = 'Service Added Successfully';
        this.openSnackBar();
      });
  }
  deleteSpecialisation(id) {
    this.loading = true;
    this.doctorservice.deleteMySpecialisation(id)
    .subscribe(
      (x) => {
        this.special = [];
        this.msg = 'Delete Successfull';
        this.getSpecialist(this.sprovider[0].id);
        this.loading = false;
        this.openSnackBar();
      });
  }
  addSpecialisation(id) {
    this.loading = true;
    this.doctorservice.addMySpecialisation(id, this.sprovider[0].id)
    .subscribe(
      (x) => {
        this.special = [];
        this.msg = 'Add Successfull';
        this.getSpecialist(this.sprovider[0].id);
        this.loading = false;
        this.openSnackBar();
      });
  }
  saveData() {
    if (this.sprovider[0].name === this.tempsprovider[0].name && this.sprovider[0].address
       === this.tempsprovider[0].address && this.sprovider[0].mobile === this.tempsprovider[0].mobile &&
       this.sprovider[0].email === this.tempsprovider[0].email && this.sprovider[0].about === 
       this.tempsprovider[0].about && this.sprovider[0].qualification === this.tempsprovider[0].qualification
      && this.sprovider[0].experience === this.tempsprovider[0].experience && this.sprovider[0].education ===
       this.tempsprovider[0].education && this.sprovider[0].expdetails === this.tempsprovider[0].expdetails &&
       this.sprovider[0].registration === this.tempsprovider[0].registration && 
       this.sprovider[0].awards === this.tempsprovider[0].awards && this.sprovider[0].membership === 
       this.tempsprovider[0].membership) {
        this.msg = 'No Change';
        this.openSnackBar();
       }else {
         this.loading = true;
         this.doctorservice.changeMyprofile(this.sprovider[0].name, this.sprovider[0].address,
          this.sprovider[0].mobile,  this.sprovider[0].email, this.sprovider[0].about,
          this.sprovider[0].qualification, this.sprovider[0].experience, this.sprovider[0].education,
          this.sprovider[0].expdetails,  this.sprovider[0].registration,this.sprovider[0].awards,
          this.sprovider[0].membership, this.sprovider[0].id)
          .subscribe(
            (x) => {
              this.getData();
              this.msg = 'Change successful';
              this.openSnackBar();
            });
        }
  }
}
